module.exports = __webpack_public_path__ + "static/media/info.c7675f68.svg";